import { render } from "./layerTable.vue?vue&type=template&id=5925163a"
import script from "./layerTable.vue?vue&type=script&lang=js"
export * from "./layerTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__